var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('operate-content',{ref:"operateContent",attrs:{"refer":"createNewPage","mode":"edit","is-content-section-required":_vm.isContentSectionRequired,"outer-rules":_vm.rules}})}
var staticRenderFns = []

export { render, staticRenderFns }